// Reads Rails CSRF token from the meta tag emitted by `csrf_meta_tags` in the
// application layout. Rails rejects unsafe requests (POST/PATCH/PUT/DELETE)
// without a valid X-CSRF-Token header with 422 InvalidAuthenticityToken.
export function csrfToken(): string {
  const el = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return el?.content ?? '';
}

export function jsonHeaders(): HeadersInit {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-CSRF-Token': csrfToken(),
  };
}
